/**
 * PATH: packages/ui/src/table/tableHeaderChrome.ts
 * FILE_ID: UI-TABLE-CHROME-001
 * PURPOSE: The People-directory header paint, as the platform default.
 * WHY: Operator mandate - every hub's table header matches the People
 *      directory. Changes #447/#448 already converged Jobs Hub onto this exact
 *      string; publishing it here stops the next hub from retyping it and
 *      drifting again. Token-only: no hard-coded blue/teal/slate.
 * RELATED: SortableTableHeader.tsx,
 *   src/Pages/MainPages/TeamsHub/peopleTableConfig.js (the donor)
 */

/**
 * Sticky header cell paint, including the vertical grid rules.
 * Byte-identical to the People directory `TH` and to job-hub `JOBS_PEOPLE_TH`.
 */
export const TABLE_TH =
  'sticky top-0 z-10 border-b border-r border-border last:border-r-0 bg-card'
  + ' px-3 py-2.5 text-left text-xs font-semibold uppercase tracking-wide'
  + ' text-muted-foreground'

/**
 * The clickable sort control inside a header cell.
 *
 * People supplies the resting look (muted, brightening to foreground). The
 * focus ring is added rather than inherited: People's header button had no
 * visible focus state, which is a keyboard-accessibility defect, not a style
 * choice worth preserving.
 */
export const TABLE_SORT_BUTTON =
  'inline-flex items-center gap-1 rounded-sm select-none transition-colors'
  + ' hover:text-foreground focus-visible:outline-none'
  + ' focus-visible:ring-[3px] focus-visible:ring-ring/50'

/** Body cell grid. Same rules as the Jobs People table cells. */
export const TABLE_TD =
  'overflow-hidden text-ellipsis border-b border-r border-border/60 last:border-r-0 px-3 py-2 align-middle'

/** Row wash. Same hover as the Jobs People table. */
export const TABLE_ROW = 'hover:bg-accent/40'

/** Bordered sheet. Horizontal scroll stays inside the card. */
export const TABLE_SHELL = 'overflow-x-auto rounded-xl border border-border'
